import Api from './api';

export default {
	/**
	 * Getting all user's devices
	 * Don't call this function, use store updateDevices action
	 *
	 */
	getDevices(search) {
		var data = {
			params: {
				limit: 100,
				offset: 0,
				fields: ['DisplayName', 'Serial', 'PublicID', 'DeviceBrand', 'DeviceModel', 'WebkeyVersion', 'LastConnected', 'Online', 'Build', 'GroupID', 'Rooted']
			}
		};
		if (search.length > 2) {
			data.params.search = search;
		}

		return Api.get('devices', data);
	},
	/**
	 * Update device settings
	 *
	 */
	saveDevice(publicID, model) {
		return Api.put(`devices?publicid=${publicID}`, model);
	},
	/**
	 * Geolocate device base on lat and long
	 *
	 */
	getLocation(lat, lng) {
		return Api.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=false`);
	},
	/**
	 * Delete device
	 *
	 */
	deleteDevice(publicID) {
		return Api.delete(`devices?publicid=${publicID}`);
	},
	/**
	 * Send request to device pairing
	 *
	 */
	sendInvitation(email) {
		const data = {
			address: email
		};

		return Api.post('devices/invite', data);
	},
	/**
	 * Get installed packages for device.
	 *
	 */
	getDevicePackages(publicID) {
		return Api.get(`devices/packages?publicid=${publicID}`);
	},
	/**
	 * Get basic information from device.
	 *
	 */
	getDeviceInfo(publicID) {
		return Api.get(`devices/info?publicid=${publicID}`);
	},
	/**
	 * Create a new group
	 *
	 */
	createNewGroup(name, devices) {
		const data = {
			name: name,
			devices: devices
		};
		return Api.post(`devices/group`, data);
	},
	/**
	 * Add devices to a group
	 *
	 */
	addDevicesToGroup(groupID, devices) {
		const data = {
			devices: devices
		};
		return Api.post(`devices/group/${groupID}`, data);
	},
	/**
	 * Update device group
	 *
	 */
	updateGroup(groupID, name) {
		const data = {
			name: name
		};
		return Api.put(`devices/group/${groupID}`, data);
	},
	/**
	 * Get preview image
	 *
	 */
	getPreview(publicID) {
		return Api.get(`devices/preview?publicid=${publicID}`, { responseType: 'arraybuffer' });
	}
};



// WEBPACK FOOTER //
// ./app/services/device.js